module.exports = __webpack_public_path__ + "media/images/btn_license_for_stallion-fe4b19769b793bfea7959d094f3a639c.gif";